// @flow
import environment from '../../environment/index';
import { postCreator, getCreator, putCreator, deleteCreator } from '../../http';
import { of } from 'rxjs';

export type WishListRequest = {
  name: string;
  imageData?: FormData; // only for local request
  imageId: string;
  public?: boolean; // only for edit
};

export type UploadImageResponse = {
  +type: string;
  +id: string;
  +resourceGroup: string;
  +resourceId: string;
  +url: string;
};

export const endpoints = Object.freeze({
  GET_LIST_USER_WISH_LISTS: `${environment.apiUrl}/wishlist/:userId/:nameSlug/list`,
  GET_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:userId/:nameSlug`,
  POST_CREATE_USER_WISH_LIST: `${environment.apiUrl}/wishlist`,
  PUT_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:nameSlug`,
  DELETE_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:nameSlug`,
  POST_PRODUCT: `${environment.apiUrl}/wishlist/:userId/:nameSlug`,
  EDIT_PRODUCT: `${environment.apiUrl}/wishlist/:userId/:nameSlug/:productId`,
  DELETE_PRODUCT: `${environment.apiUrl}/wishlist/:userId/:nameSlug/:productId`,
  POST_LIKE: `${environment.apiUrl}/wishlist/:userId/:nameSlug/like`,
  POST_UNLIKE: `${environment.apiUrl}/wishlist/:userId/:nameSlug/unlike`,
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
  UPLOAD_IMAGE_URL: `${environment.apiUrl}/image/upload/url`,
});

export const getListUserWishListsApi = getCreator(fetch, endpoints.GET_LIST_USER_WISH_LISTS);
export const getUserWishListApi = getCreator(fetch, endpoints.GET_USER_WISH_LIST);
export const postCreateUserWishListApi = postCreator(fetch, endpoints.POST_CREATE_USER_WISH_LIST);
export const putUserWishListApi = putCreator(fetch, endpoints.PUT_USER_WISH_LIST);
export const deleteUserWishListApi = deleteCreator(fetch, endpoints.DELETE_USER_WISH_LIST);
export const postProductApi = postCreator(fetch, endpoints.POST_PRODUCT);
export const editProductApi = putCreator(fetch, endpoints.EDIT_PRODUCT);
export const deleteProductApi = deleteCreator(fetch, endpoints.DELETE_PRODUCT);
export const postLikeApi = postCreator(fetch, endpoints.POST_LIKE);
export const postUnlikeApi = postCreator(fetch, endpoints.POST_UNLIKE);
export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);
export const uploadImageURLApi = postCreator(fetch, endpoints.UPLOAD_IMAGE_URL);




// WEBPACK FOOTER //
// ./src/modules/wish-list/api.js